import { getArticles } from 'api/articles'
import { Separator } from 'components/common/Separator'
import { ArticlesSectionContainer } from 'components/editorial/articles/ArticlesSectionContainer'
import { ArticlesSectionGrid } from 'components/editorial/articles/ArticlesSectionGrid'
import { ArticlesSectionGridSkeleton } from 'components/editorial/articles/ArticlesSectionGridSkeleton'
import qs from 'qs'
import { Fragment } from 'react'
import { useQuery } from 'react-query'
import { ArticleCard } from '../cards/ArticleCard'

interface ArticlesSectionProps {
  title?: string
  description?: string
  className?: string
  categorySlug?: string
}

export const ArticlesSection = ({
  title,
  description,
  className,
  categorySlug,
}: ArticlesSectionProps) => {
  const { data: articles = [], isLoading } = useQuery({
    queryKey: ['articles', categorySlug],
    queryFn: async () => {
      const query = qs.stringify(
        {
          populate: [
            'seo',
            'thumbnailImage',
            'thumbnailImage.image',
            'category',
            'articleImage',
            'articleImage.image',
            'tags',
          ],
          filters: {
            category: categorySlug
              ? { name: { $eqi: categorySlug.replaceAll('-', ' ') } }
              : undefined,
          },
          pagination: {
            page: 1,
            pageSize: 100,
          },
          sort: ['id:desc'],
        },
        {
          encodeValuesOnly: true,
        }
      )

      const articles = await getArticles(query)

      return articles.data || []
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  })

  return (
    <ArticlesSectionContainer
      title={title}
      description={description}
      className={className}
    >
      {isLoading && <ArticlesSectionGridSkeleton />}

      {!isLoading && (
        <ArticlesSectionGrid>
          {articles.map((article, index) => (
            <Fragment key={index}>
              <ArticleCard key={article.id} article={article} />
              <Separator color='cool-300' className='last:hidden sm:hidden' />
            </Fragment>
          ))}

          {articles.length === 0 && <h4>No articles found...</h4>}
        </ArticlesSectionGrid>
      )}
    </ArticlesSectionContainer>
  )
}
